import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_DATA_TYPE = 'dataType'

export const fleetAnalysisSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_DATA_TYPE]: z.string().optional(),
})

export type FleetAnalysisSearchParams = z.infer<
  typeof fleetAnalysisSearchParams
>
